<script>
import VideoStreamPlayer from '@/components/Video/VideoStreamPlayer.vue'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'

const toolsAxios = getToolsClient()

export default {
  components: {
    VideoStreamPlayer,
  },
  data() {
    return {
      playerOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        errorDisplay: false,
      },
      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        errorDisplay: false,
      },
      playerFullscreenOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        errorDisplay: false,
      },
      isFullscreenPlay: true,
      isFullscreenMuted: false,
      camCount: 3,
      closeVideoData: {
        index: 0,
        video: {},
      },
      fullscreenData: {
        data: {
          imei: '',
          device: {
            imei: '',
            phone_no: '',
          },
        },
        camera: '',
        src: '',
      },
      cameraPosition: 'INOUT',
    }
  },
  computed: {
    playerFullscreen() {
      return this.$refs.videoPlayerFullscreen.player
    },
    fleetOpen() {
      return this.$store.state.video.fleetOpen
    },
    fleetClose() {
      return this.$store.state.video.fleetClose
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),

    illustrationPath() {
      return require(`@/assets/images/illustration/saas/search.svg`)
    },
  },
  watch: {
    fleetOpen(value) {
      var self = this
      if (!value) return
      setTimeout(() => {
        var index = self.$store.state.video.fleetSelection.indexOf(value)
        self.requestCommand('INOUT', true, value, index)
      }, 1000)
    },
    fleetClose(value) {
      this.requestCommand('INOUT', false, value, null)
      return this.$toast.info(`${value.vehicle.license_plate} ditutup.`)
    },
  },
  methods: {
    closeVideo(index, video) {
      this.requestCommand(this.cameraPosition, false, video, index)

      this.$store.commit('video/setVideoError', {
        vehicle_id: video.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setVideoStopped', {
        vehicle_id: video.vehicle_id,
        isStop: false,
      })
      this.$store.commit('video/setInVideoError', {
        vehicle_id: video.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setInVideoStopped', {
        vehicle_id: video.vehicle_id,
        isStop: false,
      })

      this.$store.commit('video/removeFleet', {
        index: index,
        vehicle_id: video.vehicle_id,
      })

      video.selected = false
      this.$store.commit('video/removeFleet', video)

      setTimeout(() => {
        for (let index = 0; index < this.$store.state.video.fleetSelection.length; index++) {
          this.playInVideo(true, index, this.$store.state.video.fleetSelection[index])
          this.playVideo(true, index, this.$store.state.video.fleetSelection[index])
        }
      }, 3000)

      this.$bvModal.hide('modal-video-mini')
    },
    hideModalVideo() {
      this.playFullscreenVideo(false)

      for (let index = 0; index < this.$store.state.video.fleetSelection.length; index++) {
        if (
          this.$store.state.video.cameraProps[`video${this.fullscreenData.data.vehicle_id}`] ==
            'OUT' ||
          this.$store.state.video.cameraProps[`video${this.fullscreenData.data.vehicle_id}`] ==
            'INOUT'
        ) {
          this.playVideo(true, index, this.$store.state.video.fleetSelection[index])
        }
        if (
          this.$store.state.video.cameraProps[`video${this.fullscreenData.data.vehicle_id}`] ==
            'IN' ||
          this.$store.state.video.cameraProps[`video${this.fullscreenData.data.vehicle_id}`] ==
            'INOUT'
        ) {
          this.playInVideo(true, index, this.$store.state.video.fleetSelection[index])
        }
      }
      this.$refs['modal-video'].hide()
    },

    // Player for Outside camera
    onPlayerError(player, index, data) {
      var refsName = `videoPlayer${data.vehicle_id}`
      if (this.$store.state.video.isVideoProps[`video${data.vehicle_id}`].retry < 2) {
        setTimeout(() => {
          if (this.$refs[refsName].length) {
            this.$refs[refsName][0].initialize()
          }
          this.$store.commit('video/setRetry', {
            vehicle_id: data.vehicle_id,
            retry: this.$store.state.video.isVideoProps[`video${data.vehicle_id}`].retry + 1,
          })
        }, 3000)
      } else {
        this.$store.commit('video/setVideoError', {
          vehicle_id: data.vehicle_id,
          error: true,
        })
      }
    },

    onPlayerPlay(player, index, data) {
      this.$store.commit('video/setRetry', {
        vehicle_id: data.vehicle_id,
        retry: 0,
      })
    },

    onPlayerReady(player, index, data) {
      var refsName = `videoPlayer${data.vehicle_id}`

      if (this.$refs[refsName].length) {
        this.$refs[refsName][0].player.play()
      }

      this.$store.commit('video/setPlay', {
        vehicle_id: data.vehicle_id,
        isPlay: false,
      })
    },

    playVideo(isPlay, index, data) {
      var refsName = `videoPlayer${data.vehicle_id}`

      if (!isPlay) {
        if (this.$refs[refsName].length > 0) {
          this.$refs[refsName][0].player.muted = true
          this.$refs[refsName][0].player.pause()
        }
        this.$store.commit('video/setPlay', {
          vehicle_id: data.vehicle_id,
          isPlay: !isPlay,
        })
        return
      }

      if (this.$refs[refsName].length) {
        this.$refs[refsName][0].player.play()
        this.$refs[refsName][0].player.muted = false
      }

      this.$store.commit('video/setPlay', {
        vehicle_id: data.vehicle_id,
        isPlay: !isPlay,
      })
    },

    muteVideo(isMuted, index, video) {
      var refsName = `videoPlayer${video.vehicle_id}`

      this.$refs[refsName][0].player.muted = isMuted
      this.$store.commit('video/setMuted', {
        vehicle_id: video.vehicle_id,
        isMuted: isMuted,
      })
    },

    retryVideo(index, data) {
      this.requestCommand(
        this.$store.state.video.cameraProps[`video${data.vehicle_id}`],
        true,
        data,
        index
      )
      this.$store.commit('video/setVideoError', {
        vehicle_id: data.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setVideoStopped', {
        vehicle_id: data.vehicle_id,
        error: false,
      })

      setTimeout(() => {
        var refsName = `videoPlayer${data.vehicle_id}`
        this.$refs[refsName][0].initialize()

        this.playVideo(true, index, data)
      }, 5000)
    },
    // End of player outside camera

    // Player for inside camera
    onInPlayerError(player, index, data) {
      var refsName = `videoInPlayer${data.vehicle_id}`
      if (this.$store.state.video.isInVideoProps[`video${data.vehicle_id}`].retry < 2) {
        setTimeout(() => {
          if (this.$refs[refsName].length) {
            this.$refs[refsName][0].initialize()
          }
          this.$store.commit('video/setInRetry', {
            vehicle_id: data.vehicle_id,
            retry: this.$store.state.video.isInVideoProps[`video${data.vehicle_id}`].retry + 1,
          })
        }, 3000)
      } else {
        this.$store.commit('video/setInVideoError', {
          vehicle_id: data.vehicle_id,
          error: true,
        })
      }
    },

    onInPlayerPlay(player, index, data) {
      this.$store.commit('video/setInRetry', {
        vehicle_id: data.vehicle_id,
        retry: 0,
      })
    },

    onInPlayerReady(player, index, data) {
      var refsName = `videoInPlayer${data.vehicle_id}`

      if (this.$refs[refsName].length) {
        this.$refs[refsName][0].player.play()
      }

      this.$store.commit('video/setInPlay', {
        vehicle_id: data.vehicle_id,
        isPlay: false,
      })
    },

    playInVideo(isPlay, index, data) {
      var refsName = `videoInPlayer${data.vehicle_id}`

      if (!isPlay) {
        if (this.$refs[refsName].length > 0) {
          this.$refs[refsName][0].player.muted = true

          this.$refs[refsName][0].player.pause()
        }
        this.$store.commit('video/setInPlay', {
          vehicle_id: data.vehicle_id,
          isPlay: !isPlay,
        })
        return
      }

      if (this.$refs[refsName].length) {
        this.$refs[refsName][0].player.play()

        this.$refs[refsName][0].player.muted = false
      }

      this.$store.commit('video/setInPlay', {
        vehicle_id: data.vehicle_id,
        isPlay: !isPlay,
      })
    },

    muteInVideo(isMuted, index, video) {
      var refsName = `videoInPlayer${video.vehicle_id}`

      this.$refs[refsName][0].player.muted = isMuted

      this.$store.commit('video/setInMuted', {
        vehicle_id: video.vehicle_id,
        isMuted: isMuted,
      })
    },

    retryInVideo(index, data) {
      this.requestCommand(
        this.$store.state.video.cameraProps[`video${data.vehicle_id}`],
        true,
        data,
        index
      )
      this.$store.commit('video/setInVideoError', {
        vehicle_id: data.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setInVideoStopped', {
        vehicle_id: data.vehicle_id,
        error: false,
      })

      setTimeout(() => {
        var refsName = `videoInPlayer${data.vehicle_id}`
        this.$refs[refsName][0].initialize()

        this.playInVideo(true, index, data)
      }, 5000)
    },
    // End of Player camera inside

    // Player for fullscreen
    onPlayerFullscreenError() {
      if (this.$store.state.video.isVideoFullscreenProps.retry < 2) {
        setTimeout(() => {
          this.$refs.videoPlayerFullscreen.initialize()
          this.$store.commit('video/setVideoFullscreenProp', {
            props: 'retry',
            state: this.$store.state.video.isVideoFullscreenProps.retry + 1,
          })
        }, 3000)
      } else {
        this.$store.commit('video/setVideoFullscreenProp', {
          props: 'isVideoError',
          state: true,
        })
      }
    },

    onPlayerFullscreenPlay() {
      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'retry',
        state: 0,
      })
    },

    onPlayerFullscreenReady() {
      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'isPlay',
        state: false,
      })

      this.$refs.videoPlayerFullscreen.player.play()
    },

    playFullscreenVideo(isPlay) {
      if (!isPlay) {
        if (this.$refs.videoPlayerFullscreen) {
          this.$refs.videoPlayerFullscreen.player.pause()
        }
        this.$store.commit('video/setVideoFullscreenProp', {
          props: 'isPlay',
          state: !isPlay,
        })
        return
      }

      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'isPlay',
        state: !isPlay,
      })

      this.$refs.videoPlayerFullscreen.player.play()
    },

    muteFullscreenVideo(isMuted) {
      this.$refs.videoPlayerFullscreen.player.muted = isMuted

      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'isMuted',
        state: isMuted,
      })
    },

    async retryFullscreenVideo(index, data) {
      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'isVideoError',
        state: false,
      })
      this.$store.commit('video/setVideoFullscreenProp', {
        props: 'isVideoStopped',
        state: false,
      })

      await this.requestCommand(
        this.$store.state.video.cameraProps[`video${data.vehicle_id}`],
        true,
        data,
        'fullscreen'
      )

      this.playFullscreenVideo(true)
    },

    fullscreenVideo(data, camera) {
      this.fullscreenData = {
        data: data,
        camera: camera,
        src:
          camera == 'out'
            ? this.$store.state.video.isVideoProps[`video${data.vehicle_id}`].src
            : this.$store.state.video.isInVideoProps[`video${data.vehicle_id}`].src,
      }

      for (let index = 0; index < this.$store.state.video.fleetSelection.length; index++) {
        if (
          this.$store.state.video.cameraProps[`video${data.vehicle_id}`] == 'OUT' ||
          this.$store.state.video.cameraProps[`video${data.vehicle_id}`] == 'INOUT'
        ) {
          this.playVideo(false, index, this.$store.state.video.fleetSelection[index])
        }
        if (
          this.$store.state.video.cameraProps[`video${data.vehicle_id}`] == 'IN' ||
          this.$store.state.video.cameraProps[`video${data.vehicle_id}`] == 'INOUT'
        ) {
          this.playInVideo(false, index, this.$store.state.video.fleetSelection[index])
        }
      }

      this.$bvModal.show('modal-video')

      setTimeout(() => {
        if (!this.fullscreenData.src.includes('.mp4')) {
          this.$refs.videoPlayerFullscreen.initialize()
        } else {
          this.$refs.videoPlayerFullscreen.addSourceToVideo()
        }

        this.playFullscreenVideo(true)
      }, 1000)
    },
    // End of player for fullscreen

    changeCamera(data, camera, index) {
      this.cameraPosition = camera
      this.playVideo(false, index, data)
      this.playInVideo(false, index, data)

      var refsName = `videoInPlayer${data.vehicle_id}`
      var refsOutName = `videoPlayer${data.vehicle_id}`
      const urlInside = `https://rtmp.mceasy.id/1/${data.device.imei}.m3u8`
      const urlOutside = `https://rtmp.mceasy.id/0/${data.device.imei}.m3u8`

      if (camera == 'IN') {
        if (this.$refs[refsName][0] !== undefined && this.$refs[refsName][0].hls) {
          this.$refs[refsName][0].hls.destroy()
          this.$store.commit('video/setInSrc', {
            vehicle_id: data.vehicle_id,
            src: urlInside,
          })
        }
      } else if (camera == 'OUT') {
        if (this.$refs[refsOutName][0] !== undefined && this.$refs[refsOutName][0].hls) {
          this.$refs[refsOutName][0].hls.destroy()
          this.$store.commit('video/setSrc', {
            vehicle_id: data.vehicle_id,
            src: urlOutside,
          })
        }
      } else if (camera == 'INOUT') {
        if (this.$refs[refsName][0] !== undefined && this.$refs[refsName][0].hls) {
          this.$refs[refsName][0].hls.destroy()
          this.$store.commit('video/setInSrc', {
            vehicle_id: data.vehicle_id,
            src: urlInside,
          })
        }

        if (this.$refs[refsOutName][0] !== undefined && this.$refs[refsOutName][0].hls) {
          this.$refs[refsOutName][0].hls.destroy()
          this.$store.commit('video/setSrc', {
            vehicle_id: data.vehicle_id,
            src: urlOutside,
          })
        }
      }

      setTimeout(() => {
        if (this.$refs[refsName].length > 0) {
          if (!urlInside.includes('.mp4')) {
            this.$refs[refsName][0].initialize()
          } else {
            this.$refs[refsName][0].addSourceToVideo()
          }
        }
        if (this.$refs[refsOutName].length > 0) {
          if (!urlOutside.includes('.mp4')) {
            this.$refs[refsOutName][0].initialize()
          } else {
            this.$refs[refsOutName][0].addSourceToVideo()
          }
        }
      }, 2000)

      this.$store.commit('video/setCamera', {
        camera: camera,
        vehicle_id: data.vehicle_id,
      })
      this.$store.commit('video/setVideoError', {
        vehicle_id: data.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setVideoStopped', {
        vehicle_id: data.vehicle_id,
        isStop: false,
      })
      this.$store.commit('video/setInVideoError', {
        vehicle_id: data.vehicle_id,
        error: false,
      })
      this.$store.commit('video/setInVideoStopped', {
        vehicle_id: data.vehicle_id,
        isStop: false,
      })

      setTimeout(() => {
        this.requestCommand(camera, true, data, index)
      }, 2000)
    },

    requestCommand(camera, status, data, index) {
      if (status && index !== 'fullscreen') {
        this.$store.commit('video/setInRetry', {
          vehicle_id: data.vehicle_id,
          retry: 0,
        })
        this.$store.commit('video/setRetry', {
          vehicle_id: data.vehicle_id,
          retry: 0,
        })
      }

      const payload = {
        imei: data.device.imei,
        device_code: data.device.device_code,
        is_enable: status,
        vehicle_id: data.vehicle_id,
      }
      var self = this
      if (status && camera == 'IN') {
        payload.sensor_type = 'rtmp_in'
        toolsAxios.post('command/sensor_setting', payload).catch((error) => {
          if (error && status) {
            self.$store.commit('video/setVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
            self.$store.commit('video/setInVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
          }
          return this.$toast.error(this.$t('trackVideo.placeholder.unableToConnect'))
        })
        if (index === 'fullscreen') {
          return self.playFullscreenVideo(status)
        }
        self.playInVideo(true, index, data)
      } else if (status && camera == 'OUT') {
        payload.sensor_type = 'rtmp_out'
        toolsAxios.post('command/sensor_setting', payload).catch((error) => {
          if (error && status) {
            self.$store.commit('video/setVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
            self.$store.commit('video/setInVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
          }
          return this.$toast.error(this.$t('trackVideo.placeholder.unableToConnect'))
        })
        if (index === 'fullscreen') {
          return self.playFullscreenVideo(status)
        }
        self.playVideo(true, index, data)
      } else if (status && camera == 'INOUT') {
        payload.sensor_type = 'rtmp_inout'
        toolsAxios.post('command/sensor_setting', payload).catch((error) => {
          if (error) {
            self.$store.commit('video/setVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
            self.$store.commit('video/setInVideoError', {
              vehicle_id: data.vehicle_id,
              error: true,
            })
          }
          return this.$toast.error(this.$t('trackVideo.placeholder.unableToConnect'))
        })
        if (index === 'fullscreen') {
          return self.playFullscreenVideo(status)
        }
        self.playInVideo(true, index, data)
        self.playVideo(true, index, data)
      } else {
        if (status) {
          self.$store.commit('video/setVideoError', {
            vehicle_id: data.vehicle_id,
            error: true,
          })
          self.$store.commit('video/setInVideoError', {
            vehicle_id: data.vehicle_id,
            error: true,
          })
        } else {
          payload.sensor_type = `rtmp_${camera.toLowerCase()}`
          toolsAxios.post('command/sensor_setting', payload).catch((error) => {
            if (error) {
              self.$store.commit('video/setVideoError', {
                vehicle_id: data.vehicle_id,
                error: true,
              })
              self.$store.commit('video/setInVideoError', {
                vehicle_id: data.vehicle_id,
                error: true,
              })
            }
            return this.$toast.error(this.$t('trackVideo.placeholder.unableToConnect'))
          })
        }
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="modal-video-mini"
    title=""
    size="xl"
    hide-footer
    hide-header
    centered
    modal-class="mc-modal-video"
    no-close-on-backdrop
  >
    <b-row class="row mc-trackvideo-list">
      <b-col
        class="mc-trackvideo-list__item"
        v-for="(video, index) in $store.state.video.fleetSelection"
        :key="index"
      >
        <span class="mc-trackvideo-close">
          <i class="mc-fa icon-outline_close" @click="closeVideo(index, video)"></i>
        </span>
        <div class="mc-trackvideo-list__item-wrapper">
          <div
            class="mc-trackvideo-list__item-switch"
            style="width: fit-content; margin: 0 auto 30px; display: block"
          >
            <p style="text-align: center">{{ $t('trackVideo.camera') }}</p>
            <b-button-group size="sm">
              <b-button
                variant="primary"
                @click="changeCamera(video, 'OUT', index)"
                :class="{
                  active: $store.state.video.cameraProps[`video${video.vehicle_id}`] == 'OUT',
                }"
              >
                {{ $t('trackVideo.detail.out') }}
              </b-button>
              <b-button
                variant="primary"
                @click="changeCamera(video, 'IN', index)"
                :class="{
                  active: $store.state.video.cameraProps[`video${video.vehicle_id}`] == 'IN',
                }"
              >
                {{ $t('trackVideo.detail.in') }}
              </b-button>
              <b-button
                variant="primary"
                @click="changeCamera(video, 'INOUT', index)"
                :class="{
                  active: $store.state.video.cameraProps[`video${video.vehicle_id}`] == 'INOUT',
                }"
              >
                {{ $t('liveView.filter.all') }}
              </b-button>
            </b-button-group>
          </div>
          <b-row
            class="mc-trackvideo-list__item-video"
            :class="{
              'mc-trackvideo-list__item-video--one':
                $store.state.video.cameraProps[`video${video.vehicle_id}`] != 'INOUT' &&
                $store.state.video.fleetSelection.length == 1,
            }"
          >
            <b-col
              md="6"
              sm="12"
              :class="{
                'mc-trackvideo-list__item-video-block':
                  $store.state.video.fleetSelection.length > 1,
                'd-none': $store.state.video.cameraProps[`video${video.vehicle_id}`] == 'IN',
              }"
            >
              <div class="mc-trackvideo-list__item-video-wrapper">
                <div class="d-flex justify-content-between">
                  <label>{{ $t('trackVideo.detail.outerCamera') }}</label>
                </div>
                <div class="mc-trackvideo-list__item-video-content">
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
                    v-if="
                      !$store.state.video.isVideoProps[`video${video.vehicle_id}`].isVideoError &&
                      !$store.state.video.isVideoProps[`video${video.vehicle_id}`].isVideoStopped
                    "
                  >
                    <div class="mc-trackvideo-list__item-video-content-open-source">
                      <video-stream-player
                        :ref="`videoPlayer${video.vehicle_id}`"
                        class="vjs-custom-skin"
                        :src="$store.state.video.isVideoProps[`video${video.vehicle_id}`].src"
                        :playerId="`videoPlayer${video.vehicle_id}`"
                        @error="onPlayerError($event, index, video)"
                        @loadeddata="onPlayerPlay($event, index, video)"
                        @ready="onPlayerReady($event, index, video)"
                      >
                      </video-stream-player>
                    </div>
                    <div
                      class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action"
                    >
                      <div>
                        <span>
                          <i
                            class="mc-fa icon-outline_play-circle"
                            v-if="
                              $store.state.video.isVideoProps[`video${video.vehicle_id}`].isPlay
                            "
                            @click="playVideo(true, index, video)"
                          ></i>
                          <i
                            class="mc-fa icon-outline_pause-circle"
                            v-if="
                              !$store.state.video.isVideoProps[`video${video.vehicle_id}`].isPlay
                            "
                            @click="playVideo(false, index, video)"
                          ></i>
                        </span>
                      </div>
                      <div>
                        <span>
                          <i
                            class="mc-fa icon-outline_volume-up"
                            v-if="
                              !$store.state.video.isVideoProps[`video${video.vehicle_id}`].isMuted
                            "
                            @click="muteVideo(true, index, video)"
                          ></i>
                          <i
                            class="mc-fa icon-outline_volume-off"
                            v-if="
                              $store.state.video.isVideoProps[`video${video.vehicle_id}`].isMuted
                            "
                            @click="muteVideo(false, index, video)"
                          ></i>
                        </span>
                        <i
                          class="mc-fa icon-outline_expand"
                          @click="fullscreenVideo(video, 'out', index)"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
                    v-if="$store.state.video.isVideoProps[`video${video.vehicle_id}`].isVideoError"
                  >
                    <div class="text-center">
                      <i class="mc-fa icon-outline_wifi-off"></i>
                      <p class="text-primary">{{ $t('trackVideo.deviceUnreachable') }}.</p>
                      <b-button variant="primary" size="sm" @click="retryVideo(index, video)">{{
                        $t('global.tryAgain')
                      }}</b-button>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-close"
                    v-if="
                      $store.state.video.isVideoProps[`video${video.vehicle_id}`].isVideoStopped
                    "
                  >
                    <div>
                      <i class="mc-fa icon-outline_video-off"></i>
                      <p class="text-primary">{{ $t('trackVideo.text.stopStreaming') }}</p>
                      <b-button variant="primary" size="sm" @click="retryVideo(index, video)">{{
                        $t('global.continue')
                      }}</b-button>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
                    v-if="$store.state.video.isVideoProps[`video${video.vehicle_id}`].isLoading"
                  >
                    <div>
                      <span>
                        <i class="fa fa-circle"></i>
                        <i class="fa fa-circle"></i>
                        <i class="fa fa-circle"></i>
                      </span>
                      <p class="text-primary">{{ $t('global.reconnect') }}...</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              md="6"
              sm="12"
              :class="{
                'mc-trackvideo-list__item-video-block':
                  $store.state.video.fleetSelection.length > 1,
                'd-none': $store.state.video.cameraProps[`video${video.vehicle_id}`] == 'OUT',
              }"
            >
              <div class="mc-trackvideo-list__item-video-wrapper">
                <div class="d-flex justify-content-between">
                  <label>{{ $t('trackVideo.detail.innerCamera') }}</label>
                </div>
                <div class="mc-trackvideo-list__item-video-content">
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
                    v-if="
                      !$store.state.video.isInVideoProps[`video${video.vehicle_id}`].isVideoError &&
                      !$store.state.video.isInVideoProps[`video${video.vehicle_id}`].isVideoStopped
                    "
                  >
                    <div class="mc-trackvideo-list__item-video-content-open-source">
                      <video-stream-player
                        :ref="`videoInPlayer${video.vehicle_id}`"
                        class="vjs-custom-skin"
                        :src="$store.state.video.isInVideoProps[`video${video.vehicle_id}`].src"
                        :playerId="`videoInPlayer${video.vehicle_id}`"
                        @error="onInPlayerError($event, index, video)"
                        @loadeddata="onInPlayerPlay($event, index, video)"
                        @ready="onInPlayerReady($event, index, video)"
                      >
                      </video-stream-player>
                    </div>
                    <div
                      class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action"
                    >
                      <div>
                        <span>
                          <i
                            class="mc-fa icon-outline_play-circle"
                            v-if="
                              $store.state.video.isInVideoProps[`video${video.vehicle_id}`].isPlay
                            "
                            @click="playInVideo(true, index, video)"
                          ></i>
                          <i
                            class="mc-fa icon-outline_pause-circle"
                            v-if="
                              !$store.state.video.isInVideoProps[`video${video.vehicle_id}`].isPlay
                            "
                            @click="playInVideo(false, index, video)"
                          ></i>
                        </span>
                      </div>
                      <div>
                        <span>
                          <i
                            class="mc-fa icon-outline_volume-up"
                            v-if="
                              !$store.state.video.isInVideoProps[`video${video.vehicle_id}`].isMuted
                            "
                            @click="muteInVideo(true, index, video)"
                          ></i>
                          <i
                            class="mc-fa icon-outline_volume-off"
                            v-if="
                              $store.state.video.isInVideoProps[`video${video.vehicle_id}`].isMuted
                            "
                            @click="muteInVideo(false, index, video)"
                          ></i>
                        </span>
                        <i
                          class="mc-fa icon-outline_expand"
                          @click="fullscreenVideo(video, 'in', index)"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
                    v-if="
                      $store.state.video.isInVideoProps[`video${video.vehicle_id}`].isVideoError
                    "
                  >
                    <div class="text-center">
                      <i class="mc-fa icon-outline_wifi-off"></i>
                      <p class="text-primary">{{ $t('trackVideo.deviceUnreachable') }}.</p>
                      <b-button variant="primary" size="sm" @click="retryInVideo(index, video)">{{
                        $t('global.tryAgain')
                      }}</b-button>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-close"
                    v-if="
                      $store.state.video.isInVideoProps[`video${video.vehicle_id}`].isVideoStopped
                    "
                  >
                    <div>
                      <i class="mc-fa icon-outline_video-off"></i>
                      <p class="text-primary">{{ $t('trackVideo.text.stopStreaming') }}</p>
                      <b-button variant="primary" size="sm" @click="retryInVideo(index, video)">{{
                        $t('global.continue')
                      }}</b-button>
                    </div>
                  </div>
                  <div
                    class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
                    v-if="$store.state.video.isInVideoProps[`video${video.vehicle_id}`].isLoading"
                  >
                    <div>
                      <span>
                        <i class="fa fa-circle"></i>
                        <i class="fa fa-circle"></i>
                        <i class="fa fa-circle"></i>
                      </span>
                      <p class="text-primary">{{ $t('global.reconnect') }}...</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mc-trackvideo-list__item-bottom">
            <b-col>
              <span class="d-block text-muted">{{ $t('global.phoneNumber') }} GPS</span>
              <strong class="mc-trackvideo-list__bold-text">{{
                video.device.phone_no || '-'
              }}</strong>
            </b-col>
            <b-col class="text-end">
              <span class="d-block text-muted">IMEI</span>
              <strong class="mc-trackvideo-list__bold-text">{{ video.device.imei }}</strong>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="modal-video"
      title=""
      size="xl"
      hide-footer
      hide-header
      centered
      ref="modal-video"
      modal-class="mc-modal-video"
      no-close-on-backdrop
    >
      <div class="mc-modal-video__Wrapper">
        <div class="mc-modal-video__top">
          <b-row>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.phoneNumber') }} GPS</span>
                <strong v-if="fullscreenData.data">
                  {{ fullscreenData.data.device.phone_no || '-' }}
                </strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">IMEI</span>
                <strong v-if="fullscreenData.data">{{
                  fullscreenData.data.device.imei || '-'
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('trackVideo.cameraType') }}</span>
                <strong>{{
                  fullscreenData.camera == 'out'
                    ? $t('trackVideo.detail.outerCamera')
                    : $t('trackVideo.detail.innerCamera')
                }}</strong>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="mc-modal-video__content">
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
            v-if="!$store.state.video.isVideoFullscreenProps.isVideoError"
          >
            <div class="mc-trackvideo-list__item-video-content-open-source">
              <video-stream-player
                ref="videoPlayerFullscreen"
                class="vjs-custom-skin"
                :src="fullscreenData.src"
                :playerId="`videoPlayerFullscreen${fullscreenData.data.vehicle_id}`"
                @error="onPlayerFullscreenError($event)"
                @loadeddata="onPlayerFullscreenPlay($event)"
                @ready="onPlayerFullscreenReady($event)"
              >
              </video-stream-player>
            </div>
            <div
              class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action"
            >
              <div>
                <span>
                  <i
                    class="mc-fa icon-outline_play-circle"
                    v-if="$store.state.video.isVideoFullscreenProps.isPlay"
                    @click="playFullscreenVideo(true)"
                  ></i>
                  <i
                    class="mc-fa icon-outline_pause-circle"
                    v-if="!$store.state.video.isVideoFullscreenProps.isPlay"
                    @click="playFullscreenVideo(false)"
                  ></i>
                </span>
              </div>
              <div>
                <span>
                  <i
                    class="mc-fa icon-outline_volume-up"
                    v-if="!$store.state.video.isVideoFullscreenProps.isMuted"
                    @click="muteFullscreenVideo(true)"
                  ></i>
                  <i
                    class="mc-fa icon-outline_volume-off"
                    v-if="$store.state.video.isVideoFullscreenProps.isMuted"
                    @click="muteFullscreenVideo(false)"
                  ></i>
                </span>
                <i class="mc-fa icon-outline_collapse" @click="hideModalVideo"></i>
              </div>
            </div>
          </div>
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
            v-if="$store.state.video.isVideoFullscreenProps.isVideoError"
          >
            <i class="mc-fa icon-outline_close" @click="hideModalVideo"></i>
            <div class="text-center">
              <i class="mc-fa icon-outline_wifi-off"></i>
              <p class="text-primary">{{ $t('trackVideo.deviceUnreachable') }}.</p>
              <b-button
                variant="primary"
                size="sm"
                @click="retryFullscreenVideo(0, fullscreenData.data)"
                >{{ $t('global.tryAgain') }}</b-button
              >
            </div>
          </div>
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-close"
            v-if="$store.state.video.isVideoFullscreenProps.isVideoStopped"
          >
            <div>
              <i class="mc-fa icon-outline_video-off"></i>
              <p class="text-primary">{{ $t('trackVideo.text.stopStreaming') }}</p>
              <b-button variant="primary" size="sm">{{ $t('global.continue') }}</b-button>
            </div>
          </div>
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-error"
            v-if="$store.state.video.isVideoFullscreenProps.isLoading"
          >
            <div>
              <span>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
                <i class="fa fa-circle"></i>
              </span>
              <p class="text-primary">{{ $t('global.reconnect') }}...</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </b-modal>
</template>
